"use strict";
exports.__esModule = true;
exports.NullUUID = void 0;
exports.NullUUID = "00000000-0000-0000-0000-000000000000";
//# sourceMappingURL=constants.js.map